import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';

import { MeasurementCalculationsComponent } from '../measurement-calculations/measurement-calculations.component';

@Component({
  selector: 'app-measurement-calculations-modal',
  templateUrl: './measurement-calculations-modal.component.html',
  styleUrls: ['./measurement-calculations-modal.component.scss']
})
export class MeasurementCalculationsModalComponent {
  @ViewChild(MeasurementCalculationsComponent) measurementCalculationsComponent!: MeasurementCalculationsComponent;

  get form(): UntypedFormGroup {
    return this.measurementCalculationsComponent.form;
  }

  constructor() {}

  onFooterLinkFunction(): void {
    this.measurementCalculationsComponent.resetForm();
  }

  onSubmit(): Observable<any> {
    return of({});
  }
}
